import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://qzzuxieznqawppiduqwc.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6enV4aWV6bnFhd3BwaWR1cXdjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYwNjI5MDksImV4cCI6MjA4MTYzODkwOX0.wdQM6V4SLQ7dcSgTApwNKMFCHRP-UrMZrIo_Ca9HXEE';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
